import {ThunkAction} from '@modifi/redux'
import {
  selectPublicRegisteredCompany,
  selectPublicRegisteredCompanyLegalRepresentatives,
  selectPublicRegisteredCompanyUltimateBeneficialOwners,
} from '../../../../data/public-registered-companies'

export const selectInitialFormData = (
  state: Record<string, any>
): {initialValues: Record<string, any>; defaultValues: Record<string, any>} => {
  const selectedDataSource = selectPublicRegisteredCompany(state)

  if (!selectedDataSource) {
    return {initialValues: {}, defaultValues: {}}
  }

  const initialValues = {}
  const defaultValues = {
    legalRepresentatives: selectPublicRegisteredCompanyLegalRepresentatives(state).map(
      (person: {providerPersonId: string}) => person.providerPersonId
    ),
    ultimateBeneficialOwners: selectPublicRegisteredCompanyUltimateBeneficialOwners(state).map(
      (person: {providerPersonId: string}) => person.providerPersonId
    ),
  }

  return {initialValues, defaultValues}
}

export const aInitializePage = (): ThunkAction<any, any, any, any> => async (): Promise<void> => {
  // const countryCode = selectCurrentCompaniesCountryCode(getState())
  // const companyName = selectCompanyName(getState())
  //
  // if (countryCode && companyName) {
  //   const dataSourceCompanies = selectPublicRegisteredCompanies(
  //     getState(),
  //     countryCode,
  //     companyName
  //   )
  //   console.log(dataSourceCompanies)
  //   // if (dataSourceCompanies.length > 1) {
  //   //   dispatch(aSetPublicRegisteredCompany(dataSourceCompanies[0].providerCompanyId))
  //   // }
  // }
}
